const Animate = {
  init() {
    this.events();
  },

  events() {
    // On load.
    setTimeout(function () {
      Animate.elements();
      Animate.roll();
    }, 200);

    // On scroll
    $(window).on("scroll", function () {
      Animate.elements();
      Animate.roll();
    });
  },

  initElements() {
    return;
    $(".animate")
      .not(".animate-animated")
      .each(function () {
        block.addClass("animate-delay-" + index);
      });
  },

  elements() {
    let showAt = Animate.getShowAt();

    $(".animate")
      .not(".animate-animated")
      .each(function () {
        let block = $(this);
        let currentOffset = block.offset().top;

        // Add class if in viewport
        if (currentOffset < showAt) {
          // If multiple elements at the same top offset, add classes in chain
          block.addClass("animate-animated");
        }
      });
  },

  roll() {
    let windowScrolled = $(window).scrollTop() + $(window).height();

    let showAt = Animate.getShowAt();

    $(".roll")
      .not(".roll-rolled")
      .each(function () {
        let block = $(this);
        let currentOffset = block.offset().top;

        if (currentOffset + block.height() < showAt || currentOffset < showAt) {
          let count_to = block.data("count");
          if (typeof count_to === "number") {
            block.prop("Counter", 0).animate(
              {
                Counter: count_to,
              },
              {
                duration: 4000,
                easing: "swing",
                step(now) {
                  block.text(Math.ceil(now));
                },
              }
            );
          } else {
            block.text(count_to);
          }

          block.addClass("roll-rolled");
        }
      });
  },

  getShowAt() {
    let documentHeight = $(document).height();
    let windowScrolled = $(window).scrollTop();

    let showAt;

    if (windowScrolled > documentHeight - $(window).height() * 0.2) {
      showAt = documentHeight - 100;
    } else if ($(window).width() > 900) {
      // Show at 20% from bottom
      showAt = windowScrolled + $(window).height() * 0.8;
    } else {
      // Show at 5% from bottom
      showAt = windowScrolled + $(window).height() * 0.95;
    }

    return showAt;
  },
};

export default Animate;
